import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { PartnerCategoryType } from './partner-category-type-entity';


export class PartnerCategory extends BaseEntity {

    partnerCategoryCode     : string;
    name                    : string;
    rank                    : number;
    

    partnerCategoryTypes        : PartnerCategoryType[];
}